module.exports = __webpack_public_path__ + "img/empty.babf184c.png";